import {Component, OnDestroy, OnInit} from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';
import { Group } from 'app/models/group.model';
import { DepartmentTree } from '../../models/department-tree';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReportDatepickerComponent } from '../../modals/report-datepicker.component';
import { ReportType } from '../../models/report-type.model';
import {AdminService} from '../../services/admin.service';
import { SortTableService } from '../../services/sort-table.service';
import { UserService } from '../../services/user.service';

interface StructureGroup extends Group {
  parentDepartmentId?: string;
}

const GROUP_LIST_NAME = 'allGroupList';
const GROUP_SORT_FIELD = 'title';
const HTTP_NO_CONTENT = 204;

@Component({
  selector: 'app-company-structure',
  templateUrl: './company-structure.component.html',
  styleUrls: ['./company-structure.component.css']
})
export class CompanyStructureComponent implements OnInit, OnDestroy {
  noGroupsInfo = true;
  getGroupsErrorInfo = false;
  isLoaded = false;
  allGroupList: StructureGroup[] = [];
  tree = new DepartmentTree();
  private destroy$ = new Subject<void>();
  private groupsLoading = false;
  dataListVector = [];
  suc = false;
  nodata = false;
  isAdmin = false;
	isUser = false;
	isHead = false;
  user;
  mainGroup;

  constructor(private adminService: AdminService,
    public sortTableService: SortTableService, private modalService: NgbModal, public userService: UserService ) {
      this.mainGroup = JSON.parse(localStorage.getItem('User')).mainGroup;
  }

  ngOnInit() {
    this.checkRole();
    this.loadGroups();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadGroups(): void {
    if (this.groupsLoading) {
      return;
    }
    this.groupsLoading = true;
    this.isLoaded = false;
    this.allGroupList = [];
    this.tree.setGroups([]);
    this.adminService.getAllGroups().takeUntil(this.destroy$)
      .subscribe(response => this.acceptGroups(response), () => this.failGroups());
  }

  trackByGroupId(index: number, group: StructureGroup): string {
    return group.id;
  }

  private acceptGroups(response: HttpResponse<Object>): void {
    const groups = response.status === HTTP_NO_CONTENT ? [] : response.body;
    if (!Array.isArray(groups)) {
      this.failGroups();
      return;
    }
    this.allGroupList = groups as StructureGroup[];
    this.sortTableService.sortList(GROUP_LIST_NAME, this.allGroupList, GROUP_SORT_FIELD);
    this.tree.setGroups(this.allGroupList);
    this.groupsLoading = false;
    this.getGroupsErrorInfo = false;
    this.noGroupsInfo = !this.allGroupList.length;
    this.isLoaded = true;
  }

  private failGroups(): void {
    this.groupsLoading = false;
    this.noGroupsInfo = true;
    this.getGroupsErrorInfo = true;
    this.isLoaded = true;
  }

  sortGroups(): void {
    this.sortTableService.sortList(GROUP_LIST_NAME, this.allGroupList, GROUP_SORT_FIELD, true);
    this.tree.setGroups(this.allGroupList);
  }

  checkRole() {
		this.user = this.userService.getLocal();
		if (this.user.roles.indexOf('ROLE_HEAD') !== -1) {
			this.isHead = true;
		} else {
			this.isHead = false;
		}
		if (this.user.roles.indexOf('ROLE_ADMIN') !== -1) {
			this.isAdmin = true;
		} else {
			this.isAdmin = false;
		}
		if (this.user.roles.indexOf('ROLE_USER') !== -1) {
			this.isUser = true;
		} else {
			this.isUser = false;
		} 
	}

  openReportDatepickerVector() {
		this.dataListVector = [];
		const modalRef = this.modalService.open(ReportDatepickerComponent);
		modalRef.componentInstance.reportType = ReportType.BY_VECTOR_ALL_GROUP;
		modalRef.result.then((result) => {
			if (result === 'ok') {
				this.dataListVector = JSON.parse(localStorage.getItem('dataList'));
        
				if(this.dataListVector.length === 0) {
					this.nodata = true;
					setTimeout(() => this.nodata = false, 3000);
				} else {
					this.suc = true;
					setTimeout(() => this.suc = false, 3000);
				}
			}
		});
	}
 
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/company-structure/company-structure.component.ts